import { Link } from "react-router";
import { buttonClassName } from "@client/components/ui/button-variants";
import { commonCopy } from "@client/locales/id/common";

const copy = commonCopy.notFound;

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col items-center justify-center gap-6 px-4 text-center">
      <p className="font-mono text-xs tracking-widest text-foreground-muted">{copy.code}</p>
      <h1 className="text-gradient text-3xl font-semibold tracking-tight md:text-4xl">
        {copy.title}
      </h1>
      <p className="text-foreground-muted">{copy.description}</p>
      <Link to="/" className={buttonClassName("secondary")}>
        {copy.backHome}
      </Link>
    </main>
  );
}
